import { Action, createReducer, on } from '@ngrx/store';
import { Formulario } from '../../types/formulario.types';
import * as ProjectsActions from './projects.actions';
import { MapLayer } from './projects.types';

export const featureKey = 'projects';

export type MapLayerWithZoom = MapLayer & {
  // zoom: number;
  maxZoom: number;
  minZoom: number;
};

export type PortalMode = 'ovi' | 'icad' | 'simples' | null;
export interface State {
  // additional entity state properties
  pvgeoId: number | null;
  pvgeoGeomsQty: number | null;
  ouvCollabId: number | null;
  icadId: number | null;
  icadGeomsQty: number | null;
  zoneId: number | null;
  icadAPIAddr: string | null;
  mode: PortalMode;
  hasBothPortalModes: boolean;
  icadDefault: boolean;
  extent: any | null;
  legend: any | null;
  city: string | null;
  configuracao: any;
  vm2CoreMedian: number | null;
  layers: MapLayer[];
  layersForms: { [layerName: string]: Formulario[] } | null;
  currentPvgeoId: number | null;
  currentOuvCollabId: number | null;
  currentIcadId: number | null;
  currentZoneId: number | null;
}

export const initialState: State = {
  // additional entity state properties
  pvgeoId: -1,
  pvgeoGeomsQty: 0,
  ouvCollabId: -1,
  icadId: -1,
  icadGeomsQty: 0,
  zoneId: -1,
  icadAPIAddr: null,
  extent: null,
  // TODO ICAD
  legend: null,
  city: null,
  configuracao: null,
  layersForms: null,
  vm2CoreMedian: null,
  mode: 'icad',
  hasBothPortalModes: false,
  icadDefault: false,
  layers: [],

  currentPvgeoId: null,
  currentOuvCollabId: null,
  currentIcadId: null,
  currentZoneId: null,
};

export const projectsReducer = createReducer(
  initialState,
  on(ProjectsActions.setProjectsLayers, (state, { layers }) => {
    return {
      ...state,
      layers,
    };
  }),
  on(
    ProjectsActions.updateMapLayerGeoJSONStr,
    (state, { layerID, geoJSONStr }) => ({
      ...state,
      layers: state.layers.map((l) =>
        l.id === layerID
          ? {
              ...l,
              geoJSONStr,
            }
          : l
      ),
    })
  ),
  on(ProjectsActions.getProjectsIdsSuccess, (state, { ids }) => {
    return {
      ...state,
      pvgeoId: ids.pvgeoId,
      pvgeoGeomsQty: ids.pvgeoGeomsQty,
      ouvCollabId: ids.ouvCollabId,
      icadId: ids.icadId,
      icadGeomsQty: ids.icadGeomsQty,
      icadAPIAddr: ids.icadAPIAddr,
      zoneId: ids.zoneId,

      currentPvgeoId: ids.pvgeoId,
      currentOuvCollabId: ids.ouvCollabId,
      currentIcadId: ids.icadId,
      currentZoneId: ids.zoneId,
    };
  }),
  on(ProjectsActions.clearOuvProjectsIds, (state) => {
    return {
      ...state,
      pvgeoId: null,
      ouvCollabId: null,
    };
  }),
  on(ProjectsActions.clearICADProjectId, (state) => {
    return {
      ...state,
      icadId: null,
      // icadAPIAddr: null,
    };
  }),
  on(ProjectsActions.getProjectExtentSuccess, (state, { extent }) => {
    return {
      ...state,
      extent,
    };
  }),
  on(ProjectsActions.getProjectLegendSuccess, (state, { legend }) => {
    return {
      ...state,
      legend,
    };
  }),
  on(ProjectsActions.setCity, (state, { city }) => {
    return {
      ...state,
      city,
    };
  }),
  on(ProjectsActions.setConfiguracao, (state, { configuracao }) => {
    return {
      ...state,
      configuracao,
    };
  }),
  on(
    ProjectsActions.getLayerFormsSuccess,
    (state, { layerForms, layerName }) => {
      return {
        ...state,
        layersForms: {
          ...state.layersForms,
          [layerName]: layerForms,
        },
      };
    }
  ),
  on(ProjectsActions.getVM2CoreMedianSuccess, (state, { vm2CoreMedian }) => {
    return {
      ...state,
      vm2CoreMedian,
    };
  }),
  on(ProjectsActions.setPortalMode, (state, { mode }) => {
    return {
      ...state,
      mode,
    };
  }),
  on(ProjectsActions.setHasBothPortalModes, (state, { hasBothPortalModes }) => {
    return {
      ...state,
      hasBothPortalModes,
    };
  }),
  on(ProjectsActions.setIsICADDefault, (state, { icadDefault }) => {
    return {
      ...state,
      icadDefault,
    };
  })
);

export function reducer(state: State | undefined, action: Action) {
  return projectsReducer(state, action);
}

export const getPvgeoId = (state: State) => state.pvgeoId;
export const getPvgeoGeomsQty = (state: State) => state.pvgeoGeomsQty;
export const getOuvCollabId = (state: State) => state.ouvCollabId;
export const getIcadId = (state: State) => state.icadId;
export const getIcadGeomsQty = (state: State) => state.icadGeomsQty;
export const getZoneId = (state: State) => state.zoneId;
export const getIcadAPIAddr = (state: State) => state.icadAPIAddr;
export const getExtent = (state: State) => state.extent;
export const getLegend = (state: State) => state.legend;
export const getLayersForms = (state: State) => state.layersForms;
export const getLayers = (state: State) => state.layers;
export const getCity = (state: State) => state.city;
export const getConfiguracao = (state: State) => state.configuracao;
export const getVm2CoreMedian = (state: State) => state.vm2CoreMedian;
export const getMode = (state: State) => state.mode;
export const getHasBothPortalModes = (state: State) => state.hasBothPortalModes;
export const getICADDefault = (state: State) => state.icadDefault;

export const getCurrentPvgeoId = (state: State) => state.currentPvgeoId;
export const getCurrentOuvCollabId = (state: State) => state.currentOuvCollabId;
export const getCurrentIcadId = (state: State) => state.currentIcadId;
export const getCurrentZoneId = (state: State) => state.currentZoneId;
